<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
  @if (totalCount > 0) {
    <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
      <span
        class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
        {{totalCount}}
      </span>
    </span>
  }
  <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

  <div
    class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
      <div class="sm:hidden -ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
      </div>
      <div class="text-lg font-medium leading-10">Notifications</div>
      @if (notifications.length != 0) {
        <div class="ml-auto">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon class="icon-size-5 text-current">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="clearAllNotifications()">
              <span>Clear All Notifications</span>
            </button>
          </mat-menu>
        </div>
      }
    </div>

    <!-- Content -->
    <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">

      <!-- Notifications -->
      @for (notification of notifications; track trackByFn($index, notification)) {
        <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
          [disabled]="isButtonDisabled">
          @if (notification.path) {
            <ng-container>
              <p class="flex flex-auto py-5 pl-6 cursor-pointer"
                (click)="inActiveNotifications(notification)">
                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
              </p>
            </ng-container>
          }
          @if (!notification.path) {
            <div class="flex flex-auto py-5 pl-6 cursor-pointer" (click)="inActiveNotifications(notification)">
              <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
            </div>
          }
          <div class="relative flex flex-col my-5 mr-6 ml-2">
            <!-- Indicator -->
            <!-- Remove -->
            <button class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100" mat-icon-button
              [matTooltip]="'Remove'" (click)="removeNotifications(notification)">
              <mat-icon class="icon-size-4" [disabled]="isButtonDisabled"
              [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
            </button>
          </div>
        </div>
        <ng-template #notificationContent>
          <!-- <ng-container>
          <div
            class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
            <mat-icon class="icon-size-5">
            </mat-icon>
          </div>
        </ng-container> -->
        <div class="flex flex-col flex-auto">
          <ng-container >
            <div class="row">
              @if (notification.categories) {
                <div class="col-md-6">
                  <div class="font-semibold line-clamp-1" [innerHTML]="notification.categories"></div>
                </div>
              }
              <div class="col-md-6">
                <div class="font-semibold line-clamp-1">{{notification.formattedTime}}</div>
              </div>
              @if (notification.date) {
                <div class="col-md-12">
                  <div class="font-semibold line-clamp-1" >{{notification.formattedDate}}</div>
                </div>
              }
            </div>
          </ng-container>
        @if (notification.message) {
          <div class="line-clamp-2" [matTooltip]="notification.message"
          [innerHTML]="notification.message"></div>
        }
        <div class="mt-2 text-sm leading-none text-secondary">
        </div>
      </div>
    </ng-template>
  }

  <!-- No notifications -->
  @if (!notifications || !notifications.length) {
    <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
      <div
        class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
        <mat-icon class="text-primary-700 dark:text-primary-50"
        [svgIcon]="'heroicons_outline:bell'"></mat-icon>
      </div>
      <div class="mt-5 text-2xl font-semibold tracking-tight">No notifications</div>
      <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When you have notifications,
      they will appear here.</div>
    </div>
  }

</div>

</div>

</ng-template>